<template>
  <div class="uk-scope dcs-scope">
    <div class="uk-container uk-container-flow">
      <flow
        :identification-url="identificationUrl"
        :brand="brand"
        :session-token="sessionToken"
        :theme="theme"
        :law="law"
      />
    </div>
  </div>
</template>

<script>
import Flow from "./components/Flow";

export default {
  name: "app",
  components: { Flow },
  props: {
    identificationUrl: String,
    brand: String,
    sessionToken: String,
    theme: String,
    law: {
      type: String,
      default: "ccpa"
    }
  }
};
</script>

<style>
.dcs-scope {
  margin-top: 60px;
  padding: 0;
}
</style>
